import { Component, OnInit, Input } from "@angular/core";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { Employee } from "../../core/model/employee/employee";
import { UserProfile } from "../../core/model/user-profile";
import { Bank } from "../../core/model/bank";
import { Direction } from "../../core/model/direction";
import { Departement } from "../../core/model/departement";
import { ChangerAgenceEmployee } from "../../core/model/employee/changer-agence-employee";
import { EmployeeService } from "../../core/service/employee.service";
import { BankService } from "../../core/service/bank.service";
import { DirectionService } from "../../core/service/direction.service";
import { DepartementService } from "../../core/service/departement.service";
import { UserProfileService } from "../../core/service/user-profile.service";

@Component({
  selector: "app-changer-agence-user",
  templateUrl: "./changer-agence-user.component.html",
  styleUrls: ["./changer-agence-user.component.scss"],
})
export class ChangerAgenceUserComponent implements OnInit {
  form2: FormGroup;
  pressButton: Boolean = false;
  erreur: String = "";

  @Input() employeeId;

  employee: Employee;
  employees: Employee[];
  userprofiles: UserProfile[];
  banks: Bank[];
  directions: Direction[];
  departements: Departement[];

  changerAgenceEmployee: ChangerAgenceEmployee = new ChangerAgenceEmployee();

  constructor(
    private _employeeService: EmployeeService,
    private _bankService: BankService,
    private _drectionService: DirectionService,
    private _departementService: DepartementService,
    private _userProfileService: UserProfileService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      direction: [null, Validators.compose([Validators.required])],
      departement: ["", Validators.compose([Validators.required])],
      bank: [null, Validators.compose([Validators.required])],
      roleAffected: [null, Validators.compose([Validators.required])],
      userAffected: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getEmployeeById(this.employeeId);
    this.getDirections();
    this.getBanks();
    this.getUserProfil();
  }

  getEmployeeById(employeeId) {
    this._employeeService.getEmployeeById(employeeId).subscribe(
      (data) => {
        this.employee = data;
        this.changerAgenceEmployee.username = this.employee.username;
        this.getDepartementsByDirection(this.employee.departement.direction.id);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDirections() {
    this._drectionService.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeDepartements() {
    let directionid = this.form2.controls["direction"].value;
    this.getDepartementsByDirection(directionid);
  }

  getDepartementsByDirection(directionid) {
    this._departementService.getDepartementsByDirection(directionid).subscribe(
      (data) => {
        this.departements = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getBanks() {
    this._bankService.getAllBanks().subscribe(
      (data) => {
        this.banks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUsers() {
    const roleName = this.form2.controls["roleAffected"].value;
    this._employeeService.getEmployeeByProfile(roleName).subscribe(
      (data) => {
        this.employees = data.sort((a, b) => (a.id > b.id ? 1 : -1));
        this.form2.controls["userAffected"].setValue(
          data[data.length - 1].username
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUserProfil() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.userprofiles = data.sort((a, b) =>
          a.description > b.description ? 1 : -1
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;

    this.changerAgenceEmployee.username = this.employee.username;
    this.changerAgenceEmployee.newDepartementId =
      this.form2.controls["departement"].value;
    this.changerAgenceEmployee.newBankId = this.form2.controls["bank"].value;
    this.changerAgenceEmployee.backupUsername =
      this.form2.controls["userAffected"].value;

    this._employeeService
      .changerAgence(this.changerAgenceEmployee)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          this.erreur = error.error;
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
